import { PageRequest } from '@/core/request/PageRequest';

import {
  InvoiceSituation,
  InvoiceSpecialTaxRegime,
  InvoiceTaxRegime,
  InvoiceTaxationNature,
  InvoiceTaxpayerType,
  InvoiceType,
  InvoiceTypeOfStreet,
} from '../../invoices/invoices.enums';
import { InvoiceRecipientType } from '../../invoices/invoices.enums';
import { InvoiceDocumentType } from '../../invoices/invoices.enums';
import { InvoiceEmissionGoal } from '../../invoices/invoices.enums';
import { InvoiceEmissionType } from '../../invoices/invoices.enums';
import { InvoiceOperationDestination } from '../../invoices/invoices.enums';
import {
  InvoiceItemTaxesIbsCbsCst,
  InvoiceItemTaxesIbsZfmPresumedCreditType,
  InvoiceItemTaxesRegularTaxIbsCbsCst,
} from './invoiceNoteItems.enums';

export enum TaxRegimeEnum {
  simple = 'SIMPLES_NATIONAL',
  normal = 'NORMAL_REGIME',
  simpleNationalExcessSublimitGrossRevenue = 'SIMPLE_NATIONAL_EXCESS_SUBLIMIT_GROSS_REVENUE',
  simplesNationalMei = 'SIMPLE_NATIONAL_MEI',
}

export const TaxRegimeType: Record<number, TaxRegimeEnum> = {
  1: TaxRegimeEnum.simple,
  2: TaxRegimeEnum.simpleNationalExcessSublimitGrossRevenue,
  3: TaxRegimeEnum.normal,
};

export enum CalculationType {
  percentage = 'PERCENTAGE',
  value = 'VALUE',
}

export enum InterstateAliquotEnum {
  fourPercent = 1,
  sevenPercent = 2,
  twelvePercent = 3,
}

export enum ProvisionalSharingEnum {
  forty = 'FORTY_PERCENT',
  sixty = 'SIXTY_PERCENT',
  eighty = 'EIGHTY_PERCENT',
  hundred = 'HUNDRED_PERCENT',
}

export enum TransportRouteEnum {
  maritime = 'MARITIME',
  river = 'RIVER',
  lacustrine = 'LACUSTRINE',
  aerial = 'AERIAL',
  postcard = 'POSTCARD',
  railway = 'RAILWAY',
  highway = 'HIGHWAY',
  conduit = 'CONDUIT',
  ownMeans = 'OWN_MEANS',
  inputOutput = 'INPUT_OUTPUT',
  courier = 'COURIER',
  handcarry = 'HANDCARRY',
}

export enum ImportTypeEnum {
  own = 'OWN',
  ownAndOrder = 'OWN_AND_ORDER',
  order = 'ORDER',
}

export enum OriginSelectEnum {
  zero = '0',
  one = '1',
  two = '2',
  tree = '3',
  four = '4',
  five = '5',
  six = '6',
  seven = '7',
  eight = '8',
}

export enum ModalityIcmsEnum {
  addedValue = 'ADDED_VALUE',
  Schedule = 'SCHEDULE',
  fixedPrice = 'FIXED_PRICE',
  transactionValue = 'TRANSACTION_VALUE',
}

export enum ModalityIcmsStEnum {
  fixedPrice = 'FIXED_PRICE',
  negativeList = 'NEGATIVE_LIST',
  positiveList = 'POSITIVE_LIST',
  neutralList = 'NEUTRA_LIST',
  addedValue = 'ADDED_VALUE',
  schedule = 'SCHEDULE',
}

export enum RelevanceScaleIndicatorEnum {
  producedOnARelevantScale = 'PRODUCED_ON_A_RELEVANT_SCALE',
  producedAtNonRelevantScale = 'PRODUCED_AT_NON_RELEVANT_SCALE',
}

export enum TypeEnum {
  part = 'PART',
  consumable = 'CONSUMABLE',
  task = 'TASK',
}

export enum ChargeabilityIssEnum {
  chargeable = 'CHARGEABLE',
  notIncident = 'NOT_INCIDENT',
  exemption = 'EXEMPTION',
  export = 'EXPORT',
  immunity = 'IMMUNITY',
  judicial_suspension = 'JUDICIAL_SUSPENSION',
  asministrativeSuspension = 'ASMINISTRATIVE_SUSPENSION',
}

export enum CodeUsedInDanfeEnum {
  manufacturedC0de = 'MANUFACTURER_CODE',
  iternalCode = 'INTERNAL_CODE',
  barCode = 'BAR_CODE',
  standarNfcCode = 'STANDAR_NFC_CODE',
}

export enum EnvironmentEnum {
  staging = 'STAGING',
  production = 'PRODUCTION',
}

export enum NfeIssueEnum {
  normal = 'NORMAL',
  contingency = 'CONTINGENCY',
}

export enum SpecialTaxRegimeEnum {
  microEnterprise = 'MICRO_ENTERPRISE',
  estimated = 'ESTIMATED',
  society = 'SOCIETY',
  cooperative = 'COOPERATIVE',
  mei = 'MEI',
  meepp = 'MEEPP',
}

export enum IcmsOrigin {
  NATIONAL_EXCEPT_CODES_3458 = 'NATIONAL_EXCEPT_CODES_3458',
  FOREIGN_DIRECT_IMPORT_EXCEPT_CODE_6 = 'FOREIGN_DIRECT_IMPORT_EXCEPT_CODE_6',
  FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_EXCEPT_CODE_7 = 'FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_EXCEPT_CODE_7',
  NATIONAL_CONTENT_IMPORTATION_40_70 = 'NATIONAL_CONTENT_IMPORTATION_40_70',
  NATIONAL_BASIC_PRODUCTION_PROCESS = 'NATIONAL_BASIC_PRODUCTION_PROCESS',
  NATIONAL_CONTENT_IMPORTATION_40 = 'NATIONAL_CONTENT_IMPORTATION_40',
  FOREIGN_DIRECT_IMPORT_NO_NATIONAL_SIMILAR_CAMEX = 'FOREIGN_DIRECT_IMPORT_NO_NATIONAL_SIMILAR_CAMEX',
  FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_NO_NATIONAL_SIMILAR_CAMEX = 'FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_NO_NATIONAL_SIMILAR_CAMEX',
  NATIONAL_CONTENT_IMPORTATION_70 = 'NATIONAL_CONTENT_IMPORTATION_70',
}

export const IcmsOriginIndex = {
  [IcmsOrigin.NATIONAL_EXCEPT_CODES_3458]: 0,
  [IcmsOrigin.FOREIGN_DIRECT_IMPORT_EXCEPT_CODE_6]: 1,
  [IcmsOrigin.FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_EXCEPT_CODE_7]: 2,
  [IcmsOrigin.NATIONAL_CONTENT_IMPORTATION_40_70]: 3,
  [IcmsOrigin.NATIONAL_BASIC_PRODUCTION_PROCESS]: 4,
  [IcmsOrigin.NATIONAL_CONTENT_IMPORTATION_40]: 5,
  [IcmsOrigin.FOREIGN_DIRECT_IMPORT_NO_NATIONAL_SIMILAR_CAMEX]: 6,
  [IcmsOrigin.FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_NO_NATIONAL_SIMILAR_CAMEX]: 7,
  [IcmsOrigin.NATIONAL_CONTENT_IMPORTATION_70]: 8,
};

export enum IcmsExemptionReason {
  TAXI = 'TAXI',
  PRODUCER = 'PRODUCER',
  FLEET_RENTAL = 'FLEET_RENTAL',
  DIPLOMATIC_CONSULAR = 'DIPLOMATIC_CONSULAR',
  AMAZON_MOTORCYCLES = 'AMAZON_MOTORCYCLES',
  SUFRAMA = 'SUFRAMA',
  SALE_TO_PUBLIC_AGENCY = 'SALE_TO_PUBLIC_AGENCY',
  OTHERS = 'OTHERS',
  DISABLED_DRIVER = 'DISABLED_DRIVER',
  DISABLED_NON_DRIVER = 'DISABLED_NON_DRIVER',
  OLYMPICS_2016 = 'OLYMPICS_2016',
  REQUESTED_BY_TAX_AUTHORITY = 'REQUESTED_BY_TAX_AUTHORITY',
}
export enum IcmsBaseCalculationDeterminationMode {
  MARGIN_VALUE_ADDED = 'MARGIN_VALUE_ADDED',
  TABLE_PRICE_MAX = 'TABLE_PRICE_MAX',
  LIST_PRICE_MAX = 'LIST_PRICE_MAX',
  OPERATION_VALUE = 'OPERATION_VALUE',
}

export enum IcmsStDeterminationMode {
  TABLE_PRICE_MAX = 'TABLE_PRICE_MAX',
  NEGATIVE_LIST = 'NEGATIVE_LIST',
  POSITIVE_LIST = 'POSITIVE_LIST',
  NEUTRAL_LIST = 'NEUTRAL_LIST',
  MARGIN_VALUE_ADDED = 'MARGIN_VALUE_ADDED',
  TABLE_PRICE = 'TABLE_PRICE',
  OPERATION_VALUE = 'OPERATION_VALUE',
}

export enum IpiCst {
  INPUT_RECOVERY = 'INPUT_RECOVERY',
  INPUT_TAXED_ZERO_RATE = 'INPUT_TAXED_ZERO_RATE',
  INPUT_EXEMPT = 'INPUT_EXEMPT',
  INPUT_NON_TAXABLE = 'INPUT_NON_TAXABLE',
  INPUT_IMMUNE = 'INPUT_IMMUNE',
  INPUT_SUSPENDED = 'INPUT_SUSPENDED',
  OTHER_INPUTS = 'OTHER_INPUTS',
  OUTPUT_TAXED = 'OUTPUT_TAXED',
  OUTPUT_TAXED_ZERO_RATE = 'OUTPUT_TAXED_ZERO_RATE',
  OUTPUT_EXEMPT = 'OUTPUT_EXEMPT',
  OUTPUT_NON_TAXABLE = 'OUTPUT_NON_TAXABLE',
  OUTPUT_IMMUNE = 'OUTPUT_IMMUNE',
  OUTPUT_SUSPENDED = 'OUTPUT_SUSPENDED',
  OTHER_OUTPUTS = 'OTHER_OUTPUTS',
}

export enum PisCofinsCst {
  TAXABLE_OPERATION_NORMAL_RATE = 'TAXABLE_OPERATION_NORMAL_RATE',
  TAXABLE_OPERATION_DIFFERENTIATED_RATE = 'TAXABLE_OPERATION_DIFFERENTIATED_RATE',
  TAXABLE_OPERATION_QUANTITY_RATE = 'TAXABLE_OPERATION_QUANTITY_RATE',
  TAXABLE_OPERATION_MONOPHASIC = 'TAXABLE_OPERATION_MONOPHASIC',
  TAXABLE_OPERATION_SUBSTITUTION = 'TAXABLE_OPERATION_SUBSTITUTION',
  TAXABLE_OPERATION_ZERO_RATE = 'TAXABLE_OPERATION_ZERO_RATE',
  EXEMPT_OPERATION = 'EXEMPT_OPERATION',
  NON_INCIDENCE_OPERATION = 'NON_INCIDENCE_OPERATION',
  OPERATION_WITH_SUSPENSION = 'OPERATION_WITH_SUSPENSION',
  OTHER_OUTPUT_OPERATIONS = 'OTHER_OUTPUT_OPERATIONS',
  OPERATION_WITH_INTERNAL_TAX_CREDIT = 'OPERATION_WITH_INTERNAL_TAX_CREDIT',
  OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT = 'OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT',
  OPERATION_WITH_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT',
  PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED = 'PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED',
  PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE = 'PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE',
  PRESUMED_CREDIT_EXPORT_REVENUE = 'PRESUMED_CREDIT_EXPORT_REVENUE',
  PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE = 'PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE',
  PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE = 'PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE',
  PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE = 'PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE',
  PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE = 'PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE',
  OTHER_PRESUMED_CREDITS = 'OTHER_PRESUMED_CREDITS',
  ACQUISITION_WITHOUT_CREDIT = 'ACQUISITION_WITHOUT_CREDIT',
  ACQUISITION_WITH_EXEMPTION = 'ACQUISITION_WITH_EXEMPTION',
  ACQUISITION_WITH_SUSPENSION = 'ACQUISITION_WITH_SUSPENSION',
  ACQUISITION_WITH_ZERO_RATE = 'ACQUISITION_WITH_ZERO_RATE',
  ACQUISITION_WITHOUT_INCIDENCE = 'ACQUISITION_WITHOUT_INCIDENCE',
  ACQUISITION_WITH_SUBSTITUTION = 'ACQUISITION_WITH_SUBSTITUTION',
  OTHER_INPUT_OPERATIONS = 'OTHER_INPUT_OPERATIONS',
  OTHER_OPERATIONS = 'OTHER_OPERATIONS',
}

export enum InvoiceDeductionType {
  NO_DEDUCTIONS = 'NO_DEDUCTIONS',
  MATERIALS = 'MATERIALS',
  SUBCONTRACTED_LABOR = 'SUBCONTRACTED_LABOR',
  SERVICES = 'SERVICES',
  EXTERNAL_PRODUCTION = 'EXTERNAL_PRODUCTION',
  FOOD_AND_BEVERAGES = 'FOOD_AND_BEVERAGES',
  EXPENSE_REIMBURSEMENT = 'EXPENSE_REIMBURSEMENT',
  CONSORTIUM_TRANSFER = 'CONSORTIUM_TRANSFER',
  HEALTH_PLAN_TRANSFER = 'HEALTH_PLAN_TRANSFER',
  OTHER_DEDUCTIONS = 'OTHER_DEDUCTIONS',
}

export enum InvoiceExigibility {
  EXIGIBLE = 'EXIGIBLE',
  NON_INCIDENCE = 'NON_INCIDENCE',
  EXEMPTION = 'EXEMPTION',
  EXPORT = 'EXPORT',
  IMMUNITY = 'IMMUNITY',
  JUDICIAL_SUSPENSION = 'JUDICIAL_SUSPENSION',
  ADMINISTRATIVE_SUSPENSION = 'ADMINISTRATIVE_SUSPENSION',
}

export enum InvoiceIcmsCstCsosn {
  //-----------CST------------
  TRIBUTED_FULLY = 'TRIBUTED_FULLY',
  TRIBUTED_WITH_ICMS_SUBSTITUTION = 'TRIBUTED_WITH_ICMS_SUBSTITUTION',
  REDUCED_BASE = 'REDUCED_BASE',
  EXEMPT_WITH_ICMS_SUBSTITUTION = 'EXEMPT_WITH_ICMS_SUBSTITUTION',
  EXEMPT = 'EXEMPT',
  NOT_TRIBUTED = 'NOT_TRIBUTED',
  SUSPENDED = 'SUSPENDED',
  DEFERRED = 'DEFERRED',
  PREVIOUS_ICMS_SUBSTITUTION = 'PREVIOUS_ICMS_SUBSTITUTION',
  REDUCED_BASE_WITH_ICMS_SUBSTITUTION = 'REDUCED_BASE_WITH_ICMS_SUBSTITUTION',
  OTHERS = 'OTHERS',
  //----------CSOSN-----------
  TAXATION_UNDER_SIMPLES_WITH_CREDIT_PERMISSION = 'TAXATION_UNDER_SIMPLES_WITH_CREDIT_PERMISSION',
  TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION = 'TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION',
  ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE = 'ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE',
  SIMPLES_NACIONAL_WITH_CREDIT_PERMISSION_AND_ICMS_BY_TAX_SUBSTITUTION = 'SIMPLES_NACIONAL_WITH_CREDIT_PERMISSION_AND_ICMS_BY_TAX_SUBSTITUTION',
  SIMPLES_NACIONAL_WITHOUT_CREDIT_PERMISSION_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION = 'SIMPLES_NACIONAL_WITHOUT_CREDIT_PERMISSION_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION',
  ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE_RANGE_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION = 'ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE_RANGE_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION',
  IMMUNITY = 'IMMUNITY',
  NOT_TAXED_UNDER_SIMPLES = 'NOT_TAXED_UNDER_SIMPLES',
  ICMS_PREVIOUSLY_CHARGED_BY_TAX_SUBSTITUTION = 'ICMS_PREVIOUSLY_CHARGED_BY_TAX_SUBSTITUTION',
  CSOSN_OTHERS = 'CSOSN_OTHERS',
}

export enum InvoiceIssqnExigibilityCode {
  DEMANDABLE = 'DEMANDABLE',
  NON_INCIDENCE = 'NON_INCIDENCE',
  EXEMPTION = 'EXEMPTION',
  EXPORT = 'EXPORT',
  IMMUNITY = 'IMMUNITY',
  DEMAND_SUSPENDED_JUDICIAL_DECISION = 'DEMAND_SUSPENDED_JUDICIAL_DECISION',
  DEMAND_SUSPENDED_ADMINISTRATIVE_PROCESS = 'DEMAND_SUSPENDED_ADMINISTRATIVE_PROCESS',
}

export enum InvoiceTaxType {
  EXEMPT_ISS = 'EXEMPT_ISS',
  IMMUNE = 'IMMUNE',
  NON_INCIDENCE_IN_CITY = 'NON_INCIDENCE_IN_CITY',
  NON_TAXABLE = 'NON_TAXABLE',
  WITHHELD = 'WITHHELD',
  TAXABLE_WITHIN_CITY = 'TAXABLE_WITHIN_CITY',
  TAXABLE_OUTSIDE_CITY = 'TAXABLE_OUTSIDE_CITY',
  TAXABLE_WITHIN_CITY_BY_TAKER = 'TAXABLE_WITHIN_CITY_BY_TAKER',
}

export type ValidsCsosn =
  | '101'
  | '102'
  | '103'
  | '201'
  | '202'
  | '203'
  | '300'
  | '400'
  | '500'
  | '900';

export type ValidCstIcms =
  | '00'
  | '10'
  | '20'
  | '30'
  | '40'
  | '41'
  | '50'
  | '60'
  | '70'
  | '90';

export type ValidCstPis =
  | '00'
  | '01'
  | '02'
  | '03'
  | '04'
  | '05'
  | '49'
  | '50'
  | '51'
  | '52'
  | '53'
  | '54'
  | '55'
  | '99';

export type ValidCstCofins = ValidCstPis;

export interface InvoiceNoteItemsPartsGeneral {
  cest: string;
  codif: string;
  ncmId: number;
  cfopId: number;
  origin: string;
  partId: number;
  taskId: number;
  type: TypeEnum;
  quantity: number;
  description: string;
  consumableId: number;
  valueUnitary: number;
  valueDiscount: number;
  productCodeAnp: string;
  taxBenefitCode: string;
  unitMeasurement: string;
  manufacturerMerchandiseCnpj: string;
  relevanceScaleIndicator: RelevanceScaleIndicatorEnum;
}

export interface ImportDeclarationCustomAddition {
  number: number;
  discount: number;
  drawback: number;
  manufacturerCode: string;
}

export interface ListInvoiceItemQuery extends PageRequest {
  id: number;
}

export interface GetInvoiceItemResponse {
  cfopCode: string;
  description: string;
  id: number;
  quantity: number;
  total: number;
  valueDiscount: number;
  valueUnitary: number;
}

export interface InvoiceItemTaxes {
  cest: string;
  approximateTributeValue: number;
  cofinsAliquot: number;
  cofinsBaseCalculationValue: number;
  cofinsCst: string;
  cofinsRealAliquot: number;
  cofinsSoldQuantity: number;
  cofinsStAliquot: number;
  cofinsStBaseCalculation: number;
  cofinsStRealAliquot: number;
  cofinsStSoldQuantity: number;
  cofinsStValue: number;
  cofinsValue: number;
  cofinsWithheldBase: number;
  cofinsWithheldCst: string;
  cofinsWithheldRate: number;
  cofinsWithheldValue: number;
  cppWithheldRate: number;
  cppWithheldValue: number;
  csllBaseCalculationValue?: number;
  csllWithheldRate: number;
  csllWithheldValue: number;
  deductionDescription: string;
  deductionType: InvoiceDeductionType;
  exigibility: InvoiceExigibility;
  fcpBaseCalculationShare: number;
  fcpRelativeIcmsShare: number;
  generalIbptRate: number;
  generalIbptValue?: number;
  municipalIbptRate: number;
  municipalIbptValue?: number;
  stateIbptRate: number;
  stateIbptValue?: number;
  federalIbptRate: number;
  federalIbptValue?: number;
  federalTaxesWithheld?: boolean;
  icmsAliquot: number;
  icmsBaseCalculationDeterminationMode: IcmsBaseCalculationDeterminationMode;
  icmsBaseCalculationReductionPercentage: number;
  icmsBaseCalculationShare: number;
  icmsBaseCalculationValue: number;
  icmsCst: InvoiceIcmsCstCsosn;
  icmsDefermentDueValue: number;
  icmsDefermentPercentage: number;
  icmsDefermentValue: number;
  icmsDestinyUfBaseCalculationValue: number;
  icmsDestinyUfValue: number;
  icmsEffectiveAliquot: number;
  icmsEffectiveBaseCalculationReductionPercentage: number;
  icmsEffectiveBaseCalculationValue: number;
  icmsEffectiveValue: number;
  icmsExemptionReason: IcmsExemptionReason;
  icmsExemptionValue: number;
  icmsFcpAliquot: number;
  icmsFcpBaseCalculationValue: number;
  icmsFcpPercentageShare: number;
  icmsOrigin: IcmsOrigin;
  icmsSimpleNationalCreditPercentage: number;
  icmsSimpleNationalCreditValue: number;
  icmsStAliquot: number;
  icmsStBaseCalculationReductionPercentage: number;
  icmsStBaseCalculationValue: number;
  icmsStDeterminationMode: IcmsStDeterminationMode;
  icmsStFcpAliquot: number;
  icmsStFcpBaseCalculationValue: number;
  icmsStFcpValue: number;
  icmsStValue: number;
  icmsStValueAddedMarginPercentage: number;
  icmsValue: number;
  id: number;
  inssWithheldRate: number;
  inssWithheldValue: number;
  internalAliquotShare: number;
  interstateAliquotShare: number;
  interstateIcmsShare: number;
  ipiAliquot: number;
  ipiBaseCalculation: number;
  ipiControlSealCode: string;
  ipiControlSealQuantity: number;
  ipiCst: IpiCst;
  ipiLegalClassificationCode: string;
  ipiProducerCnpj: string;
  ipiUnitQuantity: number;
  ipiUnitValue: number;
  ipiValue: number;
  irrfBaseCalculationValue?: number;
  irrfWithheldRate: number;
  irrfWithheldValue: number;
  issRetentionPolicyValue: number;
  issqnAliquot: number;
  issqnBaseCalculation: number;
  issqnConditionalDiscount: number;
  issqnDeductionValue: string;
  issqnEventGeneratorMunicipalityCode: string;
  issqnExigibilityCode: InvoiceIssqnExigibilityCode;
  issqnIncidenceMunicipalityCode: string;
  issqnMunicipalServiceCode: string;
  issqnOtherValue: number;
  issqnServiceCode: string;
  issqnSuspensionProcessNumber: string;
  issqnUnconditionalDiscount: number;
  issqnValue: number;
  otherWithholdings: number;
  pisAliquot: number;
  pisBaseCalculationQuantity: number;
  pisBaseCalculationValue: number;
  pisCst: PisCofinsCst;
  pisRealAliquot: number;
  pisSoldQuantity: number;
  pisStAliquot: number;
  pisStBaseCalculation: number;
  pisStRealAliquot: number;
  pisStSoldQuantity: number;
  pisStValue: number;
  pisValue: number;
  pisWithheldBase: number;
  pisWithheldCst: string;
  pisWithheldRate: number;
  pisWithheldValue: number;
  rate: number;
  returnedGoodsPercentage: number;
  returnedIpiValue: number;
  suspensionProcess: string;
  taxType: InvoiceTaxType;
  taxable: boolean;
  taxRegime: TaxRegimeEnum;
  value: number;
  withheld?: boolean;
  withheldValue: number;
  withholdingResponsible: string;
  shouldNotDeductExemptIcms?: boolean;
  nbsCode?: string;
  // Tax reform ------------------------
  cbsAliquot?: number;
  cbsDeferralPercentage?: number;
  cbsDeferralValue?: number;
  cbsEffectiveAliquot?: number;
  cbsPresumedCreditPercentage?: number;
  cbsPresumedCreditSuspensiveConditionValue?: number;
  cbsPresumedCreditValue?: number;
  cbsReductionAliquot?: number;
  cbsTaxReturned?: number;
  cbsValue?: number;
  classificationCodePresumedCredit?: string;
  competenceApuration?: string;
  competenceCbsValue?: number;
  competenceIbsValue?: number;
  creditReversalCbsValue?: number;
  creditReversalIbsValue?: number;
  creditTransferCbsValue?: number;
  creditTransferIbsValue?: number;
  govPurchaseCbsAliquotPercentage?: number;
  govPurchaseCbsValue?: number;
  govPurchaseIbsMunicipalAliquotPercentage?: number;
  govPurchaseIbsMunicipalValue?: number;
  govPurchaseIbsUfAliquotPercentage?: number;
  govPurchaseIbsUfValue?: number;
  ibsCbsBaseCalculation?: number;
  ibsCbsCst?: InvoiceItemTaxesIbsCbsCst;
  ibsCbsDonation?: string;
  ibsCbsTaxClassification?: string;
  ibsMunicipalAliquot?: number;
  ibsMunicipalDeferralPercentage?: number;
  ibsMunicipalDeferralValue?: number;
  ibsMunicipalEffectiveAliquot?: number;
  ibsMunicipalReductionAliquot?: number;
  ibsMunicipalTaxReturned?: number;
  ibsMunicipalValue?: number;
  ibsPresumedCreditPercentage?: number;
  ibsPresumedCreditSuspensiveConditionValue?: number;
  ibsPresumedCreditValue?: number;
  ibsTotalValue?: number;
  ibsUfAliquot?: number;
  ibsUfDefermentPercentage?: number;
  ibsUfDefermentValue?: number;
  ibsUfEffectiveAliquot?: number;
  ibsUfReductionAliquot?: number;
  ibsUfTaxReturned?: number;
  ibsUfValue?: number;
  ibsZfmAssessmentPeriod?: string;
  ibsZfmPresumedCreditType?: InvoiceItemTaxesIbsZfmPresumedCreditType;
  ibsZfmPresumedCreditValue?: number;
  icmsFcpValue?: number;
  isUsedAsset?: true;
  monoAdRemCbsAliquotPercentage?: number;
  monoAdRemIbsAliquotPercentage?: number;
  monoCbsValue?: number;
  monoDeferralCbsPercentage?: number;
  monoDeferralCbsValue?: number;
  monoDeferralIbsPercentage?: number;
  monoDeferralIbsValue?: number;
  monoIbsValue?: number;
  monoItemCbsTotal?: number;
  monoItemIbsTotal?: number;
  monoQuantity?: number;
  monoRetainedAdRemCbsAliquotPercentage?: number;
  monoRetainedAdRemIbsAliquotPercentage?: number;
  monoRetainedCbsValue?: number;
  monoRetainedIbsValue?: number;
  monoRetainedQuantity?: number;
  monoRetentionAdRemCbsAliquotPercentage?: number;
  monoRetentionAdRemIbsAliquotPercentage?: number;
  monoRetentionCbsValue?: number;
  monoRetentionIbsValue?: number;
  monoRetentionQuantity?: number;
  presumedCreditBaseCalculation?: number;
  regularTaxCbsAliquotPercentage?: number;
  regularTaxCbsValue?: number;
  regularTaxIbsCbsClassificationCode?: string;
  regularTaxIbsCbsCst?: InvoiceItemTaxesRegularTaxIbsCbsCst;
  regularTaxIbsMunicipalAliquotPercentage?: number;
  regularTaxIbsMunicipalValue?: number;
  regularTaxIbsUfAliquotPercentage?: number;
  regularTaxIbsUfValue?: number;
  selectiveTaxAliquot?: number;
  selectiveTaxBaseCalculationValue?: number;
  selectiveTaxClassificationCode?: string;
  selectiveTaxCst?: string;
  selectiveTaxSpecific?: number;
  selectiveTaxTaxableQuantity?: number;
  selectiveTaxTaxableUnitMeasure?: string;
  selectiveTaxValue?: number;

  pisCofinsOwnCst?: string;
  pisCofinsOwnBase?: number;
  pisOwnRate?: number;
  pisOwnValue?: number;
  cofinsOwnRate?: number;
  cofinsOwnValue?: number;
}

export interface InvoiceItemCreateRequest {
  // ----------Campos de fora do formulário--------------
  partId?: number;
  taskId?: number;
  type?: TypeEnum;
  barCode?: string;
  consumableId?: number;
  invoiceId?: number;
  cest?: string;
  codif?: string;
  ncmId?: number;
  cfopId?: number;
  origin?: string;
  quantity?: number;
  valueTotal?: number;
  description?: string;
  expenseValue?: number;
  valueUnitary?: number;
  deliveryValue?: number;
  valueDiscount?: number;
  insuranceValue?: number;
  productCodeAnp?: string;
  taxBenefitCode?: string;
  unitMeasurement?: string;
  manufacturerMerchandiseCnpj?: string;
  relevanceScaleIndicator?: RelevanceScaleIndicatorEnum;
  additionalInformation?: string;
  approximateTaxValue?: number;
  cfop?: {
    billing?: boolean;
    code?: string;
    description?: string;
    id?: number;
    inState?: boolean;
    output?: boolean;
    outsideCountry?: boolean;
  };
  cnae?: string;
  conditionalDiscount?: number;
  deductions?: number;
  exTipi?: string;
  fciNumber?: string;
  freightValue?: number;
  grossServiceValue?: number;
  incidenceCityCode?: string;
  incidenceCityDescription?: string;
  invoice?: {
    cancellationDate?: string;
    cancellationJustification?: string;
    cceList?: [
      {
        authorizationProtocol?: string;
        description?: string;
        eventDateTime?: string;
        eventType?: string;
        id?: number;
        nfeKey?: string;
        reason?: string;
        sequenceNumber?: number;
        status?: string;
      },
    ];
    cityId?: number;
    commitmentNote?: string;
    companyAdditionalData?: string;
    companyId?: number;
    contract?: string;
    createDate?: string;
    culturalIncentivator?: boolean;
    customFields?: string;
    customerId?: number;
    customerName?: string;
    deleted?: boolean;
    departureDate?: string;
    description?: string;
    documentType?: InvoiceDocumentType;
    dueDate?: string;
    emissionDate?: string;
    emissionGoal?: InvoiceEmissionGoal;
    emissionType?: InvoiceEmissionType;
    faceToFace?: boolean;
    finalConsumer?: boolean;
    foreignCode?: string;
    id?: number;
    insurerId?: number;
    insurerName?: string;
    integrationId?: string;
    intermediaryCityCode?: string;
    intermediaryCompanyName?: string;
    intermediaryCpfCnpj?: string;
    intermediaryIndication?: number;
    intermediaryMunicipalRegistration?: string;
    invoiceType?: InvoiceType;
    key?: string;
    natureOfOperation?: string;
    number?: number;
    numberRps?: string;
    occurrenceCity?: string;
    operationDestination?: InvoiceOperationDestination;
    orderBuy?: string;
    outgoingInvoice?: boolean;
    plugNotasId?: string;
    printType?: boolean;
    publicAgency?: boolean;
    receiverSuframaRegistration?: string;
    recipientType?: InvoiceRecipientType;
    registrationIdentifier?: string;
    rpsCompetence?: string;
    sendEmail?: boolean;
    serie?: string;
    simpleNational?: boolean;
    situation?: InvoiceSituation;
    specialTaxRegime?: InvoiceSpecialTaxRegime;
    suframaRegistration?: string;
    supplierId?: number;
    supplierName?: string;
    taxAdditionalData?: string;
    taxAuthorityFreeField?: string;
    taxAuthorityFreeText?: string;
    taxIncentive?: boolean;
    taxLoadPercentage?: number;
    taxLoadSource?: string;
    taxLoadValue?: number;
    taxRegime?: InvoiceTaxRegime;
    taxationNature?: InvoiceTaxationNature;
    taxpayerFreeField?: string;
    taxpayerFreeText?: string;
    taxpayerType?: InvoiceTaxpayerType;
    typeOfStreet?: InvoiceTypeOfStreet;
  };
  itemTaxes?: InvoiceItemTaxes;
  nve?: string;
  otherValue?: number;
  purchaseNumber?: string;
  purchaseOrder?: string;
  quantityReturnedByPurchase?: number;
  returnedPurchaseItemId?: number;
  serviceItemList?: string;
  taxBase?: number;
  taxCode?: string;
  unconditionalDiscount?: number;
  fuel?: {
    ambientTemperatureBilling?: number;
    anpCode?: string;
    anpDescription?: string;
    authorizationCode?: string;
    cideCalculationBase?: number;
    cideTaxRate?: number;
    cideValue?: number;
    consumptionState?: string;
    endValue?: number;
    glpPercentage?: number;
    gniPercentage?: number;
    gnnPercentage?: number;
    id?: number;
    nozzleNumber?: string;
    pumpNumber?: string;
    startValue?: number;
    startingValue?: number;
    tankNumber?: string;
  };
  keyNfePurchase?: string;
  itemNumberPurchase?: string;
}

export interface InvoiceItemUpdateRequest extends InvoiceItemCreateRequest {
  id: number;
}

export interface InvoiceItemFormValues
  extends Omit<InvoiceItemCreateRequest, 'itemTaxes'> {
  id: number;
  itemTaxes: Omit<InvoiceItemTaxes, 'withheld' | 'federalTaxesWithheld'> & {
    withheld?: string;
    federalTaxesWithheld?: string;
  };
}

export interface InvoiceItemUpdateResponse extends InvoiceItemCreateRequest {
  id: number;
}
